// javascript-obfuscator bundle.js --output bundle.js
export class GameConstants {
    
    public static readonly GAME_WIDTH = 640;
    public static readonly GAME_HEIGHT = 800;

    public static readonly DEVELOPMENT = true;
    public static readonly VERBOSE = false;

    public static SPONSOR_FUNO = "funo";
    public static SPONSOR_LAGGED = "lagged";
    public static SPONSOR_NONE = "none";
    public static GAME_DISTRIBUTION = "GAME DISTRIBUTION";
    public static SPONSOR = GameConstants.GAME_DISTRIBUTION;

    public static readonly CATEGORIES_AMMOUNT = 7; 
    public static readonly ITEMS_PER_PAGE = 6; 

    public static readonly SAVED_GAME_DATA_KEY = "pixel-art-data-key";
}
